export enum ResourceGeneralFormFieldEnum {
    NAME = 'name',
    DESCRIPTION = 'description',
    COLOR = 'color'
}